import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
var StyledCircle = styled("div")({
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "var(--maintain-light)",
    border: "1px solid var(--green-color-50)",
});
var CircleComponent = function () {
    return _jsx(StyledCircle, {});
};
export default CircleComponent;
